import * as React from "react";
import {
  Database,
  BookOpen,
  Cpu,
  ToggleLeft,
  GraduationCap,
  Globe2,
  ScrollText,
  Activity,
  Inbox,
  FlaskConical,
  Link2,
  Boxes,
  GitCompareArrows,
  MonitorPlay,
  SquareKanban,
  Sparkles,
} from "lucide-react";
import {
  UsersIcon,
  OrganizationsIcon,
  ProductsIcon,
  DashboardIcon,
  ReportsIcon,
  SitesIcon,
  AlertsIcon,
  ProgramsIcon,
  ShieldIcon,
  SiteIcon,
  FleetIcon,
  SystemIcon,
  DatabaseIcon,
  CatalogIcon,
} from "../../../../../ui/components/Icon";

function LucideNavIcon({
  icon: Icon,
  size = 18,
}: {
  icon: React.ComponentType<{ size?: number | string; strokeWidth?: number | string }>;
  size?: number;
}) {
  return <Icon size={size} strokeWidth={1.75} />;
}

export const NavIcons = {
  users: () => <UsersIcon />,
  organizations: () => <OrganizationsIcon />,
  products: () => <ProductsIcon />,
  dashboard: () => <DashboardIcon />,
  reports: () => <ReportsIcon />,
  sites: () => <SitesIcon />,
  alerts: () => <AlertsIcon />,
  programs: () => <ProgramsIcon />,
  shield: () => <ShieldIcon size={14} />,
  site: () => <SiteIcon size={14} />,
  fleet: () => <FleetIcon size={14} />,
  system: () => <SystemIcon />,
  database: () => <DatabaseIcon />,
  catalog: () => <CatalogIcon />,
  // System module views
  "mock-data": () => <LucideNavIcon icon={Database} />,
  simulation: () => <LucideNavIcon icon={Cpu} />,
  features: () => <LucideNavIcon icon={ToggleLeft} />,
  "smart-link": () => <LucideNavIcon icon={Link2} />,
  "product-models": () => <LucideNavIcon icon={Boxes} />,
  "smart-api": () => <LucideNavIcon icon={GitCompareArrows} />,
  events: () => <LucideNavIcon icon={Activity} />,
  capture: () => <LucideNavIcon icon={Inbox} />,
  certifications: () => <LucideNavIcon icon={GraduationCap} />,
  localization: () => <LucideNavIcon icon={Globe2} />,
  history: () => <LucideNavIcon icon={ScrollText} />,
  e2e: () => <LucideNavIcon icon={FlaskConical} />,
  roadmap: () => <LucideNavIcon icon={SquareKanban} />,
  "data-catalog": () => <CatalogIcon />,
  "product-analytics": () => <LucideNavIcon icon={MonitorPlay} />,
  insights: () => <LucideNavIcon icon={Sparkles} />,
  // aliases kept for older seed rows
  book: () => <LucideNavIcon icon={BookOpen} />,
};

export function resolveNavIcon(key: string | null | undefined): React.ReactNode {
  if (!key) return undefined;
  const IconComponent = NavIcons[key as keyof typeof NavIcons];
  return IconComponent ? <IconComponent /> : undefined;
}
